export const TABLE_CONSTRAINTS = {
  MIN_COLUMN_WIDTH: 40,
  MIN_ROW_HEIGHT: 20,
  MAX_ROW_HEIGHT: 300,
  DEFAULT_CELL_PADDING: 4,
  DEFAULT_ROW_HEIGHT: 26,
  DEFAULT_COLUMN_WIDTH: 80,
  MIN_ROWS: 1,
  MIN_COLUMNS: 1,
  MAX_ROWS: 1000,
  MAX_COLUMNS: 50,
} as const;

export const TABLE_BORDER_DEFAULTS = {
  WIDTH: 1,
  COLOR: '#e3e3e3',
  STYLE: 'solid',
  PATTERN: 'all',
} as const;

export const RESIZE_THROTTLE_MS = 16;
